<template>
  <nx-fullscreen-dialog :title="$t('message.block.form.scrollytellingSpacer.title')"
                        :active="active"
                        @dismiss="dismiss">
    <template slot="toolbar-items">
      <v-btn
        color="accent"
        flat
        :disabled="!isValid"
        @click="insertBlot"
        v-html="buttonTitle"
      ></v-btn>
    </template>
    <v-container fluid pb-3>
      <v-layout>
        <v-flex offset-md2 md8 pt-4>
          <h2 class="nx-block-headline">{{ formTitle }}</h2>
          <v-select
            v-model="data.size"
            :items="selectItems"
            :label="$t('message.block.form.scrollytellingSpacer.size')"
            :hint="$t('message.block.form.scrollytellingSpacer.sizeHint')"
            persistent-hint
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </nx-fullscreen-dialog>
</template>

<script>
import DialogButton from './DialogButton';
import NxFullscreenDialog from '@/components/dialogs/FullscreenDialog';

/**
 * CodeButton Component
 *
 * Extend DialogButton component
 *
 */

export default {
  name: 'nx-scrollytelling-spacer',
  components: { NxFullscreenDialog },
  extends: DialogButton,
  props: {
    embedSize: String,
  },
  data() {
    return {
      name: 'scrollytellingSpacerEmbed',
      data: {
        size: +this.embedSize || 10,
      },
    };
  },
  computed: {
    selectItems() {
      return [
        {
          text: '100%',
          value: 100,
        },
        {
          text: '90%',
          value: 90,
        },
        {
          text: '80%',
          value: 80,
        },
        {
          text: '70%',
          value: 70,
        },
        {
          text: '60%',
          value: 60,
        },
        {
          text: '50%',
          value: 50,
        },
        {
          text: '40%',
          value: 40,
        },
        {
          text: '30%',
          value: 30,
        },
        {
          text: '20%',
          value: 20,
        },
        {
          text: '10%',
          value: 10,
        },
      ];
    },
    isValid() {
      return !!this.data.size;
    },
  },
};
</script>
